import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {ConversationDetail} from '@/features/conversations/types'
import {httpGetConversation} from '../http/conversations.http'

/**
 * A single conversation by id, for the one case the paginated list cannot cover: a deep link
 * (from a notification) pointing at a conversation that is not on the first page, which would
 * otherwise land the operator on the list with no idea which conversation they were sent to.
 *
 * It never retries and never surfaces an error: the endpoint answers 404 for a deleted
 * conversation or one the operator is not a member of, and the panel simply stays on its list.
 */
export const useConversation = (conversationId?: string | null) =>
    useQuery<ConversationDetail>({
        queryKey: [QUERY_KEYS.CONVERSATIONS, 'detail', conversationId],
        queryFn: () => httpGetConversation(conversationId ?? ''),
        enabled: !!conversationId,
        retry: false
    })
